import type { OptionalQuery as OptionalQuery_1ntks80 } from '../pages/w/[workspaceId]/config/index.page';
import type { OptionalQuery as OptionalQuery_1cec0ar } from '../pages/w/[workspaceId]/sources/[id]/analysis/index.page';

export const pagesPath = {
  '$404': {
    $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/404' as const, hash: url?.hash })
  },
  _legacyPath: (legacyPath: string[]) => ({
    $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/[...legacyPath]' as const, query: { legacyPath }, hash: url?.hash })
  }),
  'debug': {
    'auth': {
      $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/debug/auth' as const, hash: url?.hash })
    }
  },
  'w': {
    _workspaceId: (workspaceId: string | number) => ({
      'bulk_reanalysis': {
        _runId: (runId: string | number) => ({
          $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/bulk-reanalysis/[runId]' as const, query: { workspaceId, runId }, hash: url?.hash })
        }),
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/bulk-reanalysis' as const, query: { workspaceId }, hash: url?.hash })
      },
      'config': {
        'analysis': {
          $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/config/analysis' as const, query: { workspaceId }, hash: url?.hash })
        },
        'baseline_staffs': {
          _id: (id: string | number) => ({
            $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/config/baseline-staffs/[id]' as const, query: { workspaceId, id }, hash: url?.hash })
          })
        },
        'edit': {
          $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/config/edit' as const, query: { workspaceId }, hash: url?.hash })
        },
        $url: (url?: { query?: OptionalQuery_1ntks80 | undefined, hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/config' as const, query: { workspaceId, ...url?.query }, hash: url?.hash })
      },
      'home': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/home' as const, query: { workspaceId }, hash: url?.hash })
      },
      'sources': {
        _id: (id: string | number) => ({
          'analysis': {
            $url: (url?: { query?: OptionalQuery_1cec0ar | undefined, hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/sources/[id]/analysis' as const, query: { workspaceId, id, ...url?.query }, hash: url?.hash })
          }
        })
      },
      'support': {
        $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]/support' as const, query: { workspaceId }, hash: url?.hash })
      },
      $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/w/[workspaceId]' as const, query: { workspaceId }, hash: url?.hash })
    })
  },
  $url: (url?: { hash?: string | undefined } | undefined) => ({ pathname: '/' as const, hash: url?.hash })
};

export type PagesPath = typeof pagesPath;

export const staticPath = {
  apple_touch_icon_png: '/apple-touch-icon.png',
  circles_svg: '/circles.svg',
  favicon_ico: '/favicon.ico',
  icon_192_png: '/icon-192.png',
  icon_512_png: '/icon-512.png',
  icon_svg: '/icon.svg',
  manifest_json: '/manifest.json'
} as const;

export type StaticPath = typeof staticPath;
